// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3gJpJ","content":"Consent_content__2VSTD","footer":"Consent_footer__3tS1g"};